import React from 'react';
import { isOverdue } from './MilestoneTracker';

const PartnershipStatsBar = ({ partnerships }) => {
  const active    = partnerships.filter(p => p.status === 'active').length;
  const pending   = partnerships.filter(p => p.status === 'pending').length;
  const allMs     = partnerships.flatMap(p => p.milestones || []);
  const totalMs   = allMs.length;
  const doneMs    = allMs.filter(m => m.completed || m.status === 'done').length;
  const overdueMs = allMs.filter(isOverdue).length;
  const inProgMs  = allMs.filter(m => m.status === 'in_progress' && !m.completed).length;
  const partners  = Math.max(0, new Set([
    ...partnerships.map(p => p.initiator_artist_id),
    ...partnerships.map(p => p.partner_artist_id),
  ]).size - 1);

  const items = [
    { label: 'Active Deals',    value: active,    color: 'text-white', sub: null },
    { label: 'Pending',         value: pending,   color: pending > 0 ? 'text-amber-400' : 'text-zinc-600', sub: null },
    { label: 'Done',            value: totalMs > 0 ? `${doneMs}/${totalMs}` : '—', color: 'text-green-400', sub: totalMs > 0 ? `${Math.round((doneMs/totalMs)*100)}%` : null },
    { label: 'In Progress',     value: inProgMs,  color: 'text-brand-pink', sub: null },
    { label: 'Overdue',         value: overdueMs, color: overdueMs > 0 ? 'text-red-400' : 'text-zinc-700', sub: null },
    { label: 'Partners',        value: partners,  color: 'text-white', sub: null },
  ];

  return (
    <div className="grid grid-cols-3 md:grid-cols-6 gap-2">
      {items.map(({ label, value, color, sub }) => (
        <div key={label}
          className="p-3 rounded-2xl border border-white/8 bg-white/[0.04] backdrop-blur-sm space-y-0.5 text-center">
          <p className={`text-xl font-black ${color}`}>{value}</p>
          {sub && <p className="text-[9px] font-black text-brand-pink">{sub}</p>}
          <p className="text-[9px] font-black uppercase tracking-widest text-zinc-600 leading-tight">{label}</p>
        </div>
      ))}
    </div>
  );
};

export default PartnershipStatsBar;